var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.question.isReadOnlyRenderDiv()
    ? _c("div", [_vm._v(_vm._s(_vm.question.comment))])
    : _c("sv-text-area", {
        attrs: { model: _vm.question.commentTextAreaModel },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }